import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { VendorAuthProvider } from './context/VendorAuthContext';
import { SuperAdminAuthProvider } from './context/SuperAdminAuthContext';
import { HelmetProvider } from 'react-helmet-async';

// LocalStorage session isolation wrapper for /admin routes
(function() {
    const vendorKeys = ['authToken', 'token', 'userInfo', 'userSessionData'];
    
    const isAdminRoute = () => {
        return window.location.pathname.startsWith('/admin');
    };

    const originalSetItem = localStorage.setItem;
    const originalGetItem = localStorage.getItem;
    const originalRemoveItem = localStorage.removeItem;

    localStorage.setItem = function(key, value) {
        if (isAdminRoute() && vendorKeys.includes(key)) {
            sessionStorage.setItem(key, value);
            originalSetItem.call(localStorage, key, value);
            return;
        }
        originalSetItem.call(this, key, value);
    };

    localStorage.getItem = function(key) {
        if (isAdminRoute() && vendorKeys.includes(key)) {
            let val = sessionStorage.getItem(key);
            if (val !== null) return val;
            
            val = originalGetItem.call(localStorage, key);
            if (val !== null) {
                sessionStorage.setItem(key, val);
                return val;
            }
            return null;
        }
        return originalGetItem.call(this, key);
    };

    localStorage.removeItem = function(key) {
        if (isAdminRoute() && vendorKeys.includes(key)) {
            sessionStorage.removeItem(key);
            originalRemoveItem.call(localStorage, key);
            return;
        }
        originalRemoveItem.call(this, key);
    };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <VendorAuthProvider>
          <SuperAdminAuthProvider>
            <App />
          </SuperAdminAuthProvider>
        </VendorAuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
